import { Context, FC, useContext, useMemo, useRef } from "react";


export interface SelectiveContextProviderProps {
  useContextFn: () => any,
  ProviderComponent: FC<{value:any}>,
  selector?: (input: any) => any[],
  transform?: (input: any) => any,  
}

const identity = (x:any) => x

const SelectiveContextProvider: FC<SelectiveContextProviderProps> = ({
  useContextFn,
  ProviderComponent,
  children,
  selector = identity,
  transform = identity,
}) => {
  
  const ctx = useContextFn()
  const ctxRef = useRef(ctx)
  ctxRef.current = ctx

  const deps = selector(ctx)
  const value = useMemo(() => {
    return transform(ctxRef.current)
  }, deps)

  return (
    <ProviderComponent value={value}>
      {useMemo(() => children, deps)}
    </ProviderComponent>
  )
}

export default SelectiveContextProvider;
